import React, { useState } from 'react';
import { Product } from 'bootstrap/data/product/Product';
import Divider from 'components/divider/Divider';
import { useTranslation } from 'react-i18next';
import { PriceAfterTrialInfo } from '../priceaftertrialinfo/PriceAfterTrialInfo';
import { TotalPriceInfo } from '../totalpriceinfo/TotalPriceInfo';
import { useFeatures } from 'useFeatures';
import { ApplePayElement } from 'subscription/recurly/components/elements/applepay/ApplePayElement';
import MoneyBackCheck from 'assets/money_back_check_ic.svg';
import ApplyPay from 'assets/icon_btn_apple_pay.svg';
import { isApplePayAvailable } from '../Payments/Payments.utlls';
import { useRecurlyLogic } from 'subscription/recurly/Recurly.hook';
import { usePaymentsLogic } from 'subscription/recurly/components/paymentpicker/PaymentsPicker.hook';
import { PaymentMethods } from '../Payments/Payments.types';
import Alert from 'components/error/Error';
import styles from './styles.module.scss';
import { SlideUpPanel } from 'subscription/recurly/components/slideuppaymentform/SlideUpPaymentForm';
import { DefaultElements } from 'subscription/recurly/components/elements/default/DefaultElements';

type Props = {
  product: Product;
  presaleProduct?: Product;
  currencyCode?: string;
  handleGetPlanClick: () => void;
};

export const PaymentFormTemplate = ({
  product,
  presaleProduct,
  currencyCode,
  handleGetPlanClick,
}: Props) => {
  const { t } = useTranslation();

  const { isAdhdTest, isSingleSubscriptionFlow } = useFeatures();

  const showApplePay = isSingleSubscriptionFlow && isApplePayAvailable();

  const { onPaymentSuccess, onPaymentError } = useRecurlyLogic();

  const [showOtherPayments, setShowOtherPayments] = useState(false);

  const {
    handlePaymentMethodChange,
    errorMessage,
    isPaypalLoading,
    setErrorMessage,
  } = usePaymentsLogic({
    product,
    onSuccess: onPaymentSuccess,
    onError: onPaymentError,
  });

  return (
    <>
      <Alert
        visible={!!errorMessage}
        error={errorMessage}
        onClose={() => setErrorMessage('')}
      />
      <div className={styles.paymentFormTemplate}>
        {!!product.trialLength && (
          <TotalPriceInfo
            product={product}
            presaleProduct={presaleProduct}
            currencyCode={currencyCode}
          />
        )}

        <PriceAfterTrialInfo product={product} currencyCode={currencyCode} />

        {showApplePay ? (
          <div className={styles.applePayContainer}>
            <div className={styles.moneyBackGuarantee}>
              <img src={MoneyBackCheck} alt="" /> 100% money-back guarantee
            </div>
            <ApplePayElement
              showChecklist={false}
              label={
                <div className={styles.applyPayBtn}>
                  Continue with <img src={ApplyPay} />{' '}
                  <span style={{ marginLeft: '-40px', fontSize: '18px' }}>
                    Pay
                  </span>
                </div>
              }
              isLoading={isPaypalLoading}
              onPay={() => handlePaymentMethodChange(PaymentMethods.ApplePay)}
            />
            <button
              className={styles.linkButton}
              onClick={() => setShowOtherPayments(true)}
            >
              {t('See other payment methods')}
            </button>
          </div>
        ) : (
          !isAdhdTest && (
            <>
              <Divider />
              <button className={styles.submit} onClick={handleGetPlanClick}>
                {t('getPlanButton')}
              </button>
            </>
          )
        )}
      </div>

      <SlideUpPanel
        product={product}
        currencyCode={currencyCode as string}
        isOpen={showOtherPayments}
        onClose={() => setShowOtherPayments(false)}
      >
        <DefaultElements
          product={product}
          onPaymentSuccess={onPaymentSuccess}
          onPaymentError={onPaymentError}
          shouldShowPaymentLabel={false}
        />
      </SlideUpPanel>
    </>
  );
};
